import { XIcon } from '@phosphor-icons/react';

import { AF } from './styles';
import { useProductListContext } from '~/utilities/context/static/ProductListContext';
import { useClearAllAppliedFacets } from '~/utilities/hooks/search/useClearAllAppliedFacets';

type Props = Readonly<{
  className?: string;
  placement?: 'mobile' | 'desktop';
}>;

export const ClearAllFacets = ({ className, placement }: Props) => {
  const { systemTexts } = useProductListContext();
  const clearAllAppliedFacets = useClearAllAppliedFacets();

  const clearAllLabel = systemTexts?.filterAndSort?.clearAllLabel || '';

  return (
    <AF.AppliedFilterWrapper data-clear-all-placement={placement}>
      <AF.ClearAll className={className} onClick={clearAllAppliedFacets}>
        <AF.AppliedFilterLabel data-testid="clear-filters">{clearAllLabel}</AF.AppliedFilterLabel>
        <AF.RemoveAppliedIconWrapper>
          <XIcon />
        </AF.RemoveAppliedIconWrapper>
      </AF.ClearAll>
    </AF.AppliedFilterWrapper>
  );
};
